export default class CoachingNote {
  userId: string;

  constructor({ userId }: any) {
    this.userId = userId;
  }
}
